/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import { FSF_PAGES } from '../fsfPages.generated';

const DEFAULT_PAGE = 'home2026';
const HOME_CONTENT_PAGE = FSF_PAGES.home || {};
const HOME_IMAGES = {
  operations: '/wp-content/uploads/2022/05/IMG_1741.jpg',
  quality: '/wp-content/uploads/2022/05/IMG_1185-768x512.jpg',
  reviews: '/wp-content/uploads/2026/04/WEB-3.jpg',
  sustainability: '/wp-content/uploads/2026/02/2.png',
  truck: '/wp-content/uploads/2026/02/3.jpg',
  googleBusiness: '/wp-content/uploads/2026/02/gb1.png',
};
const GOOGLE_BUSINESS_URL = 'https://www.google.com/maps/search/?api=1&query=Freight%20Services%20Fiji';
const CUSTOMER_REVIEW_URL = 'https://forms.cloud.microsoft/r/zs5XPMG54D?origin=lprLink';
const TRACK_SHIPMENT_URL = 'https://www-fslsuv.wisegrid.net/Portals/NEO/Desktop';
const HOME_SERVICE_POST_SLUGS = [
  'transit-whs',
  'ocean-products',
  'airproducts',
  'insurance-product',
  'air-product',
  'ocean-product',
];
const HOME_REVIEWS = [
  {
    name: 'Rahul Kishore',
    source: 'Google',
    rating: 5,
    text: "I had a great experience with Freight Services Fiji, and with Thomas and his team. I wasn't there physically while the goods arrived but he handled everything with care and everything reached my old apartment in great shape and on time. I would definitely use FSF again in the near future. Thomas has constant follow ups and does not make you feel anxious about transporting goods across different countries!",
  },
  {
    name: 'Vasiti Lesianawai',
    source: 'Customer Review',
    rating: 5,
    text: "I highly recommend Freight Services for anyone looking for top-tier packing and shipping solutions. Their team is incredibly professional, efficient, and consistently goes above and beyond when conducting their operations. It's rare to find a logistics company that not only excels in their industry but also actively gives back. Freight Services does both, and does it exceptionally well. Hats off to their entire team for combining excellent service with genuine compassion!",
  },
  {
    name: 'Josan Cordan',
    source: 'Google',
    rating: 5,
    text: 'Last July 2024 we hired their Service and met Thom Taoi. He guided us in all the documents that we needed for us to ship our personal belongings and our Car. The transaction went very smooth and fast. We received our personal belongings from Fiji to New Zealand safe and fast. We appreciate all his help in releasing of our car. Without him it will be very difficult in our end.',
  },
  {
    name: 'Milika Ligabalavu',
    source: 'LinkedIn',
    rating: null,
    text: "I would like to sincerely thank the Freight Services (Fiji) team for the excellent service provided. Everything went well and was stress free. I was able to concentrate on work and other matters at the same time. The charges for the services rendered was the most affordable I had come across in my search for freight services. Your staff were so professional and friendly. I'm so grateful for your efficient service and will definitely engage your team again in future.",
  },
  {
    name: 'Sabina Van Vliet',
    source: 'WhatsApp',
    rating: 5,
    text: 'Fantastic Team. Tom and Rupeni managed my entire move from Singapore to Fiji to Australia. I would highly recommend FSF.',
  },
  {
    name: 'Gina Ali',
    source: 'Facebook',
    rating: 5,
    text: 'I searched through Chat GPT for a reliable company to use when moving homes. Freight services popped up from the search and they responded promptly to my enquiry. The move was the best experience as the staff packed everything for me, we moved homes within hours and I even was able to prepare dinner in our new home. Amazing!!! These guys really know service and understand value for money. Thank you Freight services, I highly recommend them.',
  },
];

const CSR_POLICY_URL = '/wp-content/uploads/2022/08/CSR-Policy.pdf';
const CSR_DOCUMENT_PAGES = [
  {
    src: '/wp-content/uploads/2023/04/CSR_Page_1.png',
    alt: 'Freight Services Fiji corporate social responsibility policy page 1',
  },
  {
    src: '/wp-content/uploads/2023/04/CSR_Page_2-725x1024.png',
    alt: 'Freight Services Fiji corporate social responsibility policy page 2',
  },
  {
    src: '/wp-content/uploads/2023/04/CSR_Page_3-725x1024.png',
    alt: 'Freight Services Fiji corporate social responsibility policy page 3',
  },
  {
    src: '/wp-content/uploads/2023/04/CSR_Page_4-725x1024.png',
    alt: 'Freight Services Fiji corporate social responsibility policy page 4',
  },
];
const CSR_FOCUS_AREAS = [
  {
    icon: 'globe',
    title: 'Sustainable Operations',
    text: 'Reducing waste, improving route choices, and encouraging responsible logistics decisions across daily work.',
  },
  {
    icon: 'heart',
    title: 'Community Impact',
    text: 'Supporting the communities we operate in and keeping people at the centre of responsible growth.',
  },
  {
    icon: 'shield',
    title: 'Accountable Growth',
    text: 'Aligning our business practices with long-term environmental, social, and governance responsibilities.',
  },
];
const HOME_PHOTOS = [
  {
    src: HOME_IMAGES.operations,
    alt: 'Freight Services Fiji branded truck connecting the Pacific to the world',
  },
  {
    src: HOME_IMAGES.quality,
    alt: 'Freight Services Fiji reception office',
  },
  {
    src: HOME_IMAGES.sustainability,
    alt: 'Freight Services Fiji sustainability billboard and certifications',
  },
  {
    src: HOME_IMAGES.truck,
    alt: 'Freight Services Fiji sustainability truck artwork',
  },
];
const HOME_SLIDESHOW_PHOTOS = [
  {
    src: '/wp-content/uploads/2022/05/IMG_0298.jpg',
    alt: 'Freight Services Fiji staff and operations',
  },
  {
    src: '/wp-content/uploads/2022/05/0-02-07-6fbbca32cfcce14cacb8f6840ff6231a22cb5a60a09b51c746b1854e8c1c3c7a_73d83be445ed67b.jpg',
    alt: 'Freight Services Fiji team member',
  },
  {
    src: '/wp-content/uploads/2022/05/IMG_1166.jpg',
    alt: 'Freight Services Fiji warehouse operations',
  },
  {
    src: '/wp-content/uploads/2022/05/0-02-07-7339a65a118bb0806c30829a0c49b2c38521d06cc57b7e897009fcd98975ae77_5bd26a4180b3e1dd-Copy.jpg',
    alt: 'Freight Services Fiji staff member',
  },
  {
    src: '/wp-content/uploads/2022/05/IMG_1411.jpg',
    alt: 'Freight Services Fiji logistics team at work',
  },
  {
    src: '/wp-content/uploads/2022/05/IMG_1185.jpg',
    alt: 'Freight Services Fiji reception and customer service area',
  },
  {
    src: '/wp-content/uploads/2026/02/mov2.png',
    alt: 'Freight Services Fiji moving services team',
  },
  {
    src: '/wp-content/uploads/2022/05/IMG_1741.jpg',
    alt: 'Freight Services Fiji branded moving truck',
  },
  {
    src: '/wp-content/uploads/2022/05/IMG_0306.jpg',
    alt: 'Freight Services Fiji team and truck in the operations yard',
  },
  {
    src: '/wp-content/uploads/2022/05/IMG_0684.jpg',
    alt: 'Freight Services Fiji team member beside a company truck',
  },
  {
    src: '/wp-content/uploads/2026/03/2025-05-26-1-e1772699829187.webp',
    alt: 'Freight Services Fiji team member with a U.S. Army service member',
  },
];
const ABOUT_WTO_REVIEW_URL = 'https://www.wto.org/english/tratop_e/tpr_e/tp53_e.htm';
const ABOUT_IMAGES = {
  wto: '/wp-content/uploads/2023/06/WTO.png',
  shipping: '/wp-content/uploads/2023/06/main-e1686518124758.jpg',
  pacific25: '/wp-content/uploads/2026/02/itb2-e1770597317633.png',
  founder: '/wp-content/uploads/2026/02/itb3.png',
  awards: '/wp-content/uploads/2026/02/itb4b-e1770597466767.png',
  compact: '/wp-content/uploads/2023/06/x1.png',
  light: '/wp-content/uploads/2023/06/trees.png',
  network: '/wp-content/uploads/2023/06/road.png',
};
const CONTACT_MAP_URL = 'https://maps.app.goo.gl/Y7qhTCFJErA7D7zJ8';
const CONTACT_MAP_EMBED_URL = 'https://www.google.com/maps?q=-18.132753,178.427175&z=17&output=embed';
const CONTACT_QUOTE_IMAGE = '/wp-content/uploads/2023/12/original-0F6419F0-D0D5-45CE-8DF2-16D7F4B4A20B-295x300.jpeg';
const CONTACT_DETAILS = [
  {
    icon: 'phone',
    label: 'Landline',
    value: '+679 5200',
    href: 'tel:+6795200',
  },
  {
    icon: 'mail',
    label: 'Email',
    value: 'info@fsf.com.fj',
    href: 'mailto:info@fsf.com.fj',
  },
  {
    icon: 'location',
    label: 'Locations',
    lines: [
      '190 Foster Road, Walu Bay, Suva',
      'Lot 20 Service Street, Navutu Subdivision, Lautoka',
    ],
    href: CONTACT_MAP_URL,
  },
  {
    icon: 'clock',
    label: 'Office Hours',
    lines: [
      'Monday - Friday: 8:00 - 17:30',
      'Saturday: 9:00 - 12:00',
      'Sunday: Closed',
    ],
  },
];
const ABOUT_PHOTOS = [
  {
    src: ABOUT_IMAGES.wto,
    alt: 'World Trade Organization logo',
  },
  {
    src: ABOUT_IMAGES.shipping,
    alt: 'Freight Services Fiji connecting the Pacific to the world',
  },
  {
    src: ABOUT_IMAGES.pacific25,
    alt: 'Connecting the Pacific for over 25 years',
  },
  {
    src: ABOUT_IMAGES.founder,
    alt: 'Freight Services Fiji founder story collage',
  },
  {
    src: ABOUT_IMAGES.awards,
    alt: 'Freight Services Fiji awards and certifications',
  },
  {
    src: ABOUT_IMAGES.compact,
    alt: 'United Nations Global Compact commitment',
  },
  {
    src: ABOUT_IMAGES.light,
    alt: 'The Light of the Pacific',
  },
  {
    src: ABOUT_IMAGES.network,
    alt: 'Pacific network and connectivity',
  },
];
const ETHICS_PHOTOS = [
  {
    src: '/wp-content/uploads/2026/04/111-1.jpg',
    alt: 'Veilomani equals unconditional love value statement',
  },
  {
    src: '/wp-content/uploads/2026/04/222-2-1024x480.jpg',
    alt: 'Veitokoni offering assistance, team certificate presentation, and Veinanumi thoughtfulness statements',
  },
  {
    src: '/wp-content/uploads/2026/04/333-2-1024x474.jpg',
    alt: 'Freight Services Fiji team photos with Veidokai respect and honor value statement',
  },
  {
    src: '/wp-content/uploads/2026/04/444-3-768x378.jpg',
    alt: 'Veirokovi modesty and humility, forklift operator, and Veikauwaitaki caring for others statements',
  },
  {
    src: '/wp-content/uploads/2026/04/555-2.jpg',
    alt: 'Solesolevaki teamwork and unity value statement',
  },
];
const QUALITY_IMAGES = {
  bsiCertificate: {
    src: '/wp-content/uploads/2026/03/bsi-1024x635.png',
    alt: 'BSI ISO 9001 certificate and certification artwork',
  },
  bsiMark: {
    src: '/wp-content/uploads/2026/03/bsi2-1024x173.png',
    alt: 'BSI logo with inspiring trust for a more resilient world',
  },
  bsiTeam: {
    src: '/wp-content/uploads/2026/03/bsi3-1024x473.png',
    alt: 'Freight Services Fiji team handling quality logistics with BSI certification mark',
  },
  faimCertificate: {
    src: '/wp-content/uploads/2026/03/faim-1024x745.png',
    alt: 'FIDI FAIMPLUS certificate and quality assurance artwork',
  },
  faimTeam: {
    src: '/wp-content/uploads/2026/03/faim2-1024x1022.png',
    alt: 'FIDI and FAIMPLUS accreditation with Freight Services Fiji moving team photos',
  },
  cornerstone: {
    src: '/wp-content/uploads/2026/03/rad-867x1024.png',
    alt: 'Freight Services Fiji customer handshake outside the office',
  },
};
const QUALITY_PHOTOS = Object.values(QUALITY_IMAGES);
const GLOBAL_NETWORK_IMAGES = {
  oceanHub: {
    src: '/wp-content/uploads/2023/06/OOHub.jpg',
    alt: 'Pacific island container vessel and Freight Services Fiji ocean hub artwork',
  },
  fidiHeader: {
    src: '/wp-content/uploads/2026/02/FIDIX-1-1024x426.jpg',
    alt: 'FIDI Global Alliance and FAIMPLUS accredited international mover banner',
  },
  fidiSeal: {
    src: '/wp-content/uploads/2026/02/gn2.png',
    alt: 'FAIM quality seal relocation services artwork',
  },
  iamHeader: {
    src: '/wp-content/uploads/2026/02/IAMXX-1-1024x220.jpg',
    alt: 'IAMX Mobility Exchange banner',
  },
  iamDirectory: {
    src: '/wp-content/uploads/2026/02/gn4-421x1024.png',
    alt: 'IAMX membership directory and validation artwork',
  },
  iamTrusted: {
    src: '/wp-content/uploads/2023/06/IAM2.jpg',
    alt: 'IAM trusted moving company badge',
  },
  iataHeader: {
    src: '/wp-content/uploads/2026/02/IATAX-1024x216.jpg',
    alt: 'IATA One Source platform banner',
  },
  iataListing: {
    src: '/wp-content/uploads/2026/02/IATAX2-1-1024x241.jpg',
    alt: 'Freight Services Fiji IATA One Source listing',
  },
  iataJourney: {
    src: '/wp-content/uploads/2026/02/gn5.png',
    alt: 'IATA accreditation journey prompt artwork',
  },
  dfaHeader: {
    src: '/wp-content/uploads/2026/02/DFAX-1024x218.jpg',
    alt: 'Digital Freight Alliance by DP World banner',
  },
  dfaNetwork: {
    src: '/wp-content/uploads/2026/02/da2-1024x539.jpg',
    alt: 'Digital freight network ship and logistics routes',
  },
  dfaLogo: {
    src: '/wp-content/uploads/2026/02/da3-1024x181.png',
    alt: 'DFA Alliance by DP World logo',
  },
  fiataHeader: {
    src: '/wp-content/uploads/2026/02/FIATAX-1024x214.jpg',
    alt: 'FIATA Global Association banner',
  },
  fiataFreight: {
    src: '/wp-content/uploads/2026/02/iata1.jpg',
    alt: 'Freight forwarding ship aircraft and global logistics artwork',
  },
  fiataGlobe: {
    src: '/wp-content/uploads/2023/06/Fiata.jpg',
    alt: 'FIATA global voice of freight logistics logo',
  },
  fiataTagline: {
    src: '/wp-content/uploads/2026/02/gn6.png',
    alt: 'International Federation of Freight Forwarders Associations tagline',
  },
  ungcHeader: {
    src: '/wp-content/uploads/2026/02/da4.png',
    alt: 'United Nations Global Compact participant banner',
  },
  ungcMission: {
    src: '/wp-content/uploads/2026/02/da5-1024x518.jpg',
    alt: 'United Nations Global Compact sustainable companies mission artwork',
  },
  cargowiseHeader: {
    src: '/wp-content/uploads/2026/02/da6.png',
    alt: 'CargoWise certified logistics service provider banner',
  },
  cargowiseBadges: {
    src: '/wp-content/uploads/2026/02/da7.png',
    alt: 'CargoWise professional specialist and operator certification badges',
  },
  cargowiseIntegration: {
    src: '/wp-content/uploads/2026/02/da8.png',
    alt: 'Certified CargoWise logistics provider integration capabilities artwork',
  },
};
const GLOBAL_NETWORK_PHOTOS = Object.values(GLOBAL_NETWORK_IMAGES);
const LOGISTICS_IMAGES = {
  containerYard: {
    src: '/wp-content/uploads/2022/05/IMG_1411-1024x683.jpg',
    alt: 'Container yard operations with a reach stacker at port',
  },
  containerStack: {
    src: '/wp-content/uploads/2022/05/IMG_1423.jpg',
    alt: 'Stacked shipping containers and forklift operations',
  },
  warehouse: {
    src: '/wp-content/uploads/2022/09/WEB-6.webp',
    alt: 'Freight Services Fiji warehouse racking and forklift handling goods',
  },
  customs: {
    src: '/wp-content/uploads/2026/02/WEB2.jpg',
    alt: 'Customs inspection and freight handling at a container',
  },
  coordination: {
    src: '/wp-content/uploads/2026/04/IMG_7015.jpg',
    alt: 'Freight Services Fiji operations team member coordinating transport',
  },
};
const LOGISTICS_PHOTOS = Object.values(LOGISTICS_IMAGES);
const LOGISTICS_SERVICE_META = [
  {
    title: 'Freight Forwarding',
    icon: 'globe',
    summary: 'Air, sea, FCL, LCL, loose cargo, and time-sensitive freight movements across the Pacific.',
  },
  {
    title: 'Customs Clearance',
    icon: 'shield',
    summary: 'Import, export, transit, quarantine, valuation, and tariff support handled by a trained team.',
  },
  {
    title: 'Warehousing',
    icon: 'warehouse',
    summary: 'Transit, product, 3PL, and bonded storage options backed by approved warehouse facilities.',
  },
  {
    title: 'Transport Solutions',
    icon: 'truck',
    summary: 'Cost-efficient road, sea, air, and ferry connections for full and less-than-truckload cargo.',
  },
  {
    title: 'Cargo Consolidation',
    icon: 'layers',
    summary: 'Buyer consolidation, import deconsolidation, and export groupage to control handling costs.',
  },
  {
    title: 'Project Cargo',
    icon: 'package',
    summary: 'Planning and handling support for oversized, complex, high-value, or non-standard cargo.',
  },
  {
    title: 'Web tracker (NEW)',
    icon: 'tracker',
    summary: 'Shipment visibility tools that help customers follow cargo progress with better transparency.',
  },
];
const LOGISTICS_FALLBACK_TABS = {
  'Project Cargo': '<p>For oversized, complex, fragile, or non-standard cargo, our logistics team coordinates the planning required to move freight safely and efficiently. We help customers align handling, route planning, equipment needs, supplier communication, and delivery timing so each movement is managed with care from start to finish.</p><ul><li>Oversized and out-of-gauge cargo planning</li><li>Supplier, carrier, and handling coordination</li><li>Route, equipment, and delivery support</li><li>Careful communication for high-value or sensitive cargo</li></ul>',
  'Web tracker (NEW)': '<p>Our web tracker improves shipment visibility by giving customers a clearer view of cargo progress. With the right shipment reference, customers can check movement updates without waiting for a manual status request, helping teams plan around arrivals, documentation, and delivery windows with more confidence.</p><ul><li>Improved visibility for shipment movements</li><li>Simple reference-based tracking</li><li>Better communication across the supply chain</li><li>Support for faster, more transparent customer updates</li></ul>',
};
const MOVING_IMAGES = {
  heroTruck: {
    src: '/wp-content/uploads/2022/05/IMG_1741.jpg',
    alt: 'Freight Services Fiji moving truck outside the Walu Bay office',
  },
  yardTeam: {
    src: '/wp-content/uploads/2022/05/IMG_0306.jpg',
    alt: 'Freight Services Fiji moving truck and coordination team in the yard',
  },
  warehouseBoxes: {
    src: '/wp-content/uploads/2022/05/IMG_1166.jpg',
    alt: 'Packed moving cartons and wrapped goods stored in Freight Services Fiji warehouse racks',
  },
  contactTruck: {
    src: '/wp-content/uploads/2022/05/IMG_0684.jpg',
    alt: 'Freight Services Fiji moving team member beside a Call 5200 truck',
  },
  vehicleHandover: {
    src: '/wp-content/uploads/2026/03/2023-02-13-1-e1772699727109.webp',
    alt: 'Customer vehicle handover outside Freight Services Fiji moving and storage office',
  },
  residentialMove: {
    src: '/wp-content/uploads/2026/03/2023-02-13-2.webp',
    alt: 'Freight Services Fiji moving trucks at a residential delivery',
  },
  vehicleLoading: {
    src: '/wp-content/uploads/2026/04/IMG_1933.jpg',
    alt: 'Freight Services Fiji team assisting with vehicle relocation',
  },
  customsMove: {
    src: '/wp-content/uploads/2022/05/IMG_0301.jpg',
    alt: 'Moving cargo inspection and coordination beside a container',
  },
};
const MOVING_PHOTOS = Object.values(MOVING_IMAGES);
const MOVING_SERVICE_META = [
  {
    title: 'International',
    icon: 'globe',
    summary: 'Overseas relocation backed by partner relationships, customs knowledge, and accredited moving processes.',
  },
  {
    title: 'Domestic',
    icon: 'truck',
    summary: 'Local household moves across Fiji with the equipment, packing support, and team to handle the job properly.',
  },
  {
    title: 'Pet',
    icon: 'heart',
    summary: 'Pet transport and relocation support so family companions can travel safely to their new home.',
  },
  {
    title: 'Motor Vehicle',
    icon: 'vehicle',
    summary: 'Import, export, clearance, registration, packing, and shipping support for personal vehicles.',
  },
  {
    title: 'Insurance',
    icon: 'shield',
    summary: 'Moving and transit insurance options for added protection around household goods and personal effects.',
  },
  {
    title: 'Transit',
    icon: 'warehouse',
    summary: 'Storage and transit support with practical risk awareness while goods are between homes or destinations.',
  },
  {
    title: 'Excess Baggage',
    icon: 'package',
    summary: 'Air and ocean options for personal baggage moving through FSF forwarding support.',
  },
  {
    title: 'Exhibitions',
    icon: 'layers',
    summary: 'Event and exhibition logistics for customers exhibiting overseas or across the islands.',
  },
];

export {
  DEFAULT_PAGE,
  HOME_CONTENT_PAGE,
  HOME_IMAGES,
  GOOGLE_BUSINESS_URL,
  CUSTOMER_REVIEW_URL,
  TRACK_SHIPMENT_URL,
  HOME_SERVICE_POST_SLUGS,
  HOME_REVIEWS,
  CSR_POLICY_URL,
  CSR_DOCUMENT_PAGES,
  CSR_FOCUS_AREAS,
  HOME_PHOTOS,
  HOME_SLIDESHOW_PHOTOS,
  ABOUT_WTO_REVIEW_URL,
  ABOUT_IMAGES,
  CONTACT_MAP_URL,
  CONTACT_MAP_EMBED_URL,
  CONTACT_QUOTE_IMAGE,
  CONTACT_DETAILS,
  ABOUT_PHOTOS,
  ETHICS_PHOTOS,
  QUALITY_IMAGES,
  QUALITY_PHOTOS,
  GLOBAL_NETWORK_IMAGES,
  GLOBAL_NETWORK_PHOTOS,
  LOGISTICS_IMAGES,
  LOGISTICS_PHOTOS,
  LOGISTICS_SERVICE_META,
  LOGISTICS_FALLBACK_TABS,
  MOVING_IMAGES,
  MOVING_PHOTOS,
  MOVING_SERVICE_META
};
